export const fetchAddressFromZip = (zip: string): Promise<any> => {
    return new Promise((resolve) => {
        new (window as any).YubinBango.Core(zip, (addr: any) => {
            resolve(addr);
        });
    });
};
